<template>
    <span>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
            :height="height"
            :width="width"
        >
            <circle cx="-437" cy="-1303" r="16" fill="#e75300" transform="translate(453 1319)" />
            <path
                d="M19.1 15.3l-5-3.2c-.5.6-1.3.9-2.1.9-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3v.3l5.1 3.3c.5-.4 1.2-.7 1.9-.7 1.7 0 3 1.3 3 3s-1.3 3-3 3c-.6 0-1.2-.2-1.7-.5L15 21.7v.3c0 1.7-1.3 3-3 3s-3-1.3-3-3 1.3-3 3-3c.8 0 1.6.4 2.2.9l5-3.1c-.2-.2-.2-.5-.2-.8 0-.2 0-.5.1-.7z"
                fill="#fff"
            />
        </svg>
    </span>
</template>
<script>
export default {
	name: 'IconShare',
	props: {
		height: {
			type: Number,
			default: 24,
		},
		width: {
			type: Number,
			default: 24,
        },
	},
};
</script>